import React from 'react';
import RoomRecordingsContainer from './RoomRecordingsContainer';

const RoomRecordings = (props) => (
  <RoomRecordingsContainer {...props} />
);

export default RoomRecordings;


// WEBPACK FOOTER //
// src/routes/RoomRecordings/index.js